// import Log from './partial/log'
// import goodsList from './partial/goods-list'
import Sku from './sku'
const partsName = (d) => {
  return (d.partsList || []).map(i => i.categoryName).join(' ')
}
export default {
  data() {
    return {
      id: null,
      loading: false,
      data: {},
      reviewable:false,
      visible: false,
    }
  },
  methods: {
    init(id , reviewable = false) {
      this.visible = true
      this.reviewable = reviewable
      if (id) {
        this.query(id)
      }
    },

    query(id) {
      this.loading = true
      this.id = id
      this.$request.product(id).then( resp => {
        this.loading = false
        if(resp.code == 0){
          
          // resp.data.partsList = this.$utils.conv(resp.data.partsList || [], {'genre':'genre'})
          
          this.data = this.$utils.conv(resp.data , {'appointment':'datetime','repairType':'assType' , 'userType':'userType' , 'device':'ticketSource' , 'createDatetime':'datetime' , partsName})

          this.data.logs = this.$utils.conv(resp.data.logs || [] , {'state':'assTicketStateForC', 'createDatetime':'datetime'}).sort((a,b) => a.id > b.id ? 1 : -1)
        }else{
          this.$Message.error({ content: resp.msg })
        }
      })
    },
  },
  render(){
    const { loading , data } = this
    const title = '查看商品 '+data.orderNo
   
    return (
      <sl-side-panel destroyOnClose={true} v-model={this.visible} mask-closable={false} title={title} loading={loading}>
        <Tabs value="t1">
          <TabPane label="基本信息" name="t1">
            <sl-detail-list col={1} label-width="100px" label-align="right" style="padding:12px;">
              {/* <sl-detail-list-item title="问题描述">
                <div>{data.description}</div>
                {
                  data.photo ? <sl-carousel images={data.photo.split(';')} /> : null
                }
              </sl-detail-list-item> */}
              <sl-detail-list-item title="商品编码">{data.carNo}</sl-detail-list-item>
              <sl-detail-list-item title="商品名称">{data.carBrandName}</sl-detail-list-item>
              <sl-detail-list-item title="商品类型">{data.partsName}</sl-detail-list-item>
              <sl-detail-list-item title="商品主图">{data.partsName}</sl-detail-list-item>
              <sl-detail-list-item title="商品图片">{data.partsName}</sl-detail-list-item>
              
            </sl-detail-list>
          </TabPane>
          <TabPane label="SKU" name="t2">
              <Sku product-id={this.id} />
          </TabPane>
          
        </Tabs>

      </sl-side-panel>
    )
  }
}